import { MAIN_DATA_SESSION_KEY } from '../consts';

export const getWebStorage = () => {
  return { session: sessionStorage.getItem(MAIN_DATA_SESSION_KEY) };
};
